'use client';
import NextTopLoader from 'nextjs-toploader';

const TopLoader = () => (
  <NextTopLoader
    color="#FF5A00" // You can change this to match your brand color
    initialPosition={0.08}
    crawlSpeed={200}
    height={3}
    crawl={true}
    showSpinner={false}
    easing="ease"
    speed={200}
    shadow="0 0 10px #FF5A00,0 0 5px #FF5A00"
  />
);

export default TopLoader;